const CheckIcon = ({color='#0F172A', width=24, height=15}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block me-[8px]">
            <path d="M19.5353 0.484222C18.9165 -0.161611 17.9116 -0.161204 17.292 0.484222L7.19574 11.0079L2.70838 6.3308C2.08875 5.68497 1.08435 5.68497 0.464721 6.3308C-0.154907 6.97663 -0.154907 8.02352 0.464721 8.66935L6.07367 14.5155C6.38329 14.8382 6.78928 15 7.19531 15C7.60134 15 8.00772 14.8386 8.31733 14.5155L19.5353 2.82273C20.1549 2.17735 20.1549 1.13001 19.5353 0.484222Z" fill={color} />
        </svg>
    )
}

export default CheckIcon;